import script from "./VInputPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./VInputPassword.vue?vue&type=script&setup=true&lang=js"

import "./VInputPassword.vue?vue&type=style&index=0&id=ff395d56&lang=css"

const __exports__ = script;

export default __exports__